import { FlagsProvider } from '@repo/flags/react';
import type { ReactNode } from 'react';

import { useFlagIdentity } from '@/hooks/use-flag-identity.hook';
import type { TemplateBuilderConfig } from '@/lib/config/template-builder-config';

/** Connects template-builder identity resolution to the shared browser flags provider. */
export function TemplateBuilderFlagsProvider({
  config,
  children,
}: {
  config: TemplateBuilderConfig;
  children: ReactNode;
}): ReactNode {
  const identityState = useFlagIdentity(config);
  return (
    <FlagsProvider
      application="template-builder-evo"
      environment={config.environment}
      identityState={identityState}
    >
      {children}
    </FlagsProvider>
  );
}
